export default function CoreFeatures() {
  const features = [
    {
      title: 'Core Flow Validation',
      description: 'Systematic walkthroughs of 5–10 critical user flows to confirm functional integrity and capture real-user failure modes and repro steps.'
    },
    {
      title: 'UX Heuristic & Severity Analysis',
      description: 'Expert UX review mapped to a severity score, with concrete remediation examples and expected business impact.'
    },
    {
      title: 'Prioritized Fix Roadmap',
      description: 'A ranked, actionable fix list with estimated dev effort and business impact so teams can implement high-ROI fixes fast.'
    },
    {
      title: 'CrownScore Baseline (0–100)',
      description: 'A single investor-grade metric combining Retention (40%), Task Success (30%), and UX Severity (30%). A CrownScore ≥75 signals readiness for larger studies and investor attention.'
    },
    {
      title: 'Session Recordings & Heatmaps',
      description: 'Whole session replays with heatmaps and timestamps plus developer-friendly notes for the top problem flows.'
    },
    {
      title: 'Bug Identification & Repro Steps',
      description: 'All defects logged with severity, reproduction steps, and short video snippets to speed dev handoff.'
    },
    {
      title: 'Behavioral & Quantitative Metrics',
      description: 'Task completion rate, funnel conversion, time-on-task, error frequency and retention lift (pre/post).'
    },
    {
      title: 'Early Monetization Diagnostic',
      description: 'Quick audit of subscription flows, ad placements and paywall UX to flag revenue leaks and quick wins.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-serif text-4xl font-bold text-[#213547] mb-4">
            Core Features
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to validate your app and prepare for growth
          </p>
        </div>

        <div className="cr-core-features">
          {features.map((feature, index) => (
            <details key={index} className="group">
              <summary className="flex items-center justify-between">
                <strong className="text-gray-900">{feature.title}</strong>
                <i className="ri-arrow-down-s-line text-xl text-gray-400 transition-transform group-open:rotate-180"></i>
              </summary>
              <p className="text-gray-600 leading-relaxed mt-2">
                {feature.description}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
